import { FC } from "react";
import { useSelector } from "react-redux";
import { TListingQueryParams, TModalsState } from "../../../../api/store/commonSlice";
import { useHGSelectorContext } from "../../../../components/common/hierarchyGroupSelector.context";
import { APP_CONFIG } from "../../../../constants/constants";
import { useGHContext } from "../contexts/groupHierarchy.context";
import ModalEditGroup from "../modalViewEditGroup";
import GroupHierarchyLevel from "./groupHierarchyLevel";

type TGroupHierarchyViewProps = {
  wrapperHeightClass?: string;
}

const GroupHierarchyView: FC<TGroupHierarchyViewProps> = ({
  wrapperHeightClass = 'h-[calc(100vh-170px)] group-[]/hierarchy-modal:h-[calc(100vh-160px)]',
}) => {
  const modalsState = useSelector((state: { commonReducer: { modals: TModalsState } }) => state.commonReducer.modals);
  const listingQueryParams: TListingQueryParams = useSelector((state: any) => state.commonReducer.listingQueryParams);
  const { groups: orgGroupsQueryParams } = listingQueryParams;

  const { hierarchyOnDisplay } = useGHContext();

  const {
    hGSelectorMode,
    selectedHGroups, // CHECK IF THIS IS DEFINED OR NOT
  } = useHGSelectorContext()

  return (
    <>
      <div className={`group-hierarchy-view relative overflow-x-auto overflow-y-hidden rounded-lg border border-gray-200 shadow-lg ${wrapperHeightClass}`}>
        {APP_CONFIG.DEBUG.DISPLAY_VERBOSE && (
          <pre className="absolute top-0 right-0 bg-white/80 text-[8px] pointer-events-none touch-none z-50">
            hGSelectorMode: {JSON.stringify(hGSelectorMode, null, 2)}<br />
            selectedHGroups: {JSON.stringify(selectedHGroups, null, 2)}<br />
            ------------------------<br />
            showReadOnlyViewForHierarchyGroup: {JSON.stringify(modalsState.showReadOnlyViewForHierarchyGroup, null, 2)}<br />
            ------------------------<br />
            hierarchyOnDisplay:<br />
            {JSON.stringify(hierarchyOnDisplay.map(levelItem => ({ ...levelItem/*, groups: `${levelItem.groups.length} group(s)`*/ })), null, 2)}
          </pre>
        )}
        {/* Header BG */}
        <div className="absolute w-full h-16 top-0 left-0 bg-accent-blue-paleO66 z-0" />
        <div className="absolute w-full h-full top-0 left-0 z-10 flex overflow-x-auto">
          {hierarchyOnDisplay.length === 0 ? (
            <>
              {/* Initializes the top level to display parents */}
              <GroupHierarchyLevel
                group_id={null}
                level={0}
              />
            </>
          ) : (
            <>
              {hierarchyOnDisplay.map((levelOnDisplay, index) => (
                <GroupHierarchyLevel
                  group_id={levelOnDisplay.group_id}
                  level={index}
                  key={`level_${index}`}
                />
              ))}
            </>
          )}
          {/* {'x'.repeat(8).split('').map((_, index) => (
          <GroupHierarchyLevel
            level={index}
            searchEnabled={index !== 1}
            key={`level_${index}`}
          />
        ))} */}
        </div>
      </div>
      <ModalEditGroup />
    </>
  );
}
export default GroupHierarchyView;